import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment externalBusinessMetadata on BusinessMetadata {
    uuid
    config {
      alternativeAppDownloadImage
    }
    homepage {
      isEnabled
      widgets {
        id
        type
        image {
          image
          link
          openLinkInNewTab
        }
        imageWithText {
          image
          header
          body
          link
          openLinkInNewTab
        }
        video {
          videoUrl
        }
        layouts {
          desktop {
            height
            width
            xOffset
            yOffset
          }
          mobile {
            height
            width
            xOffset
            yOffset
          }
        }
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
